import type { CSSProperties, PropsWithChildren } from 'react'

export const FixedWidthInputs = ({ children }: PropsWithChildren) => (
  <div
    className="contents"
    style={
      {
        '--amaze-inputWrapper-width':
          'calc((var(--spacing-inputs-and-alerts) - var(--spacing) * 1.5) / 2)',
        '--amaze-inputWrapper-width-two-column':
          'var(--spacing-inputs-and-alerts)',
      } as CSSProperties
    }
  >
    {children}
  </div>
)
